export const J_AND_T_PAGE_LIST = ['1737574596477450', '100325346215952', '105314948276699']



// WEBPACK FOOTER //
// ./src/constants/jandt.js